/**
 * 2026年世界杯参赛球队名称多语言映射
 * 基于FIFA官方名称，确保翻译准确
 */
export const teamNames = {
  // A组
  "mexico": { "en": "Mexico", "zh": "墨西哥", "ja": "メキシコ", "ko": "멕시코" },
  "south-africa": { "en": "South Africa", "zh": "南非", "ja": "南アフリカ", "ko": "남아프리카" },
  "south-korea": { "en": "South Korea", "zh": "韩国", "ja": "韓国", "ko": "대한민국" },
  "czech-republic": { "en": "Czech Republic", "zh": "捷克", "ja": "チェコ", "ko": "체코" },

  // B组
  "canada": { "en": "Canada", "zh": "加拿大", "ja": "カナダ", "ko": "캐나다" },
  "bosnia-herzegovina": { "en": "Bosnia and Herzegovina", "zh": "波黑", "ja": "ボスニア・ヘルツェゴビナ", "ko": "보스니아 헤르체고비나" },
  "qatar": { "en": "Qatar", "zh": "卡塔尔", "ja": "カタール", "ko": "카타르" },
  "switzerland": { "en": "Switzerland", "zh": "瑞士", "ja": "スイス", "ko": "스위스" },

  // C组
  "brazil": { "en": "Brazil", "zh": "巴西", "ja": "ブラジル", "ko": "브라질" },
  "morocco": { "en": "Morocco", "zh": "摩洛哥", "ja": "モロッコ", "ko": "모로코" },
  "haiti": { "en": "Haiti", "zh": "海地", "ja": "ハイチ", "ko": "아이티" },
  "scotland": { "en": "Scotland", "zh": "苏格兰", "ja": "スコットランド", "ko": "스코틀랜드" },

  // D组
  "usa": { "en": "United States", "zh": "美国", "ja": "アメリカ合衆国", "ko": "미국" },
  "paraguay": { "en": "Paraguay", "zh": "巴拉圭", "ja": "パラグアイ", "ko": "파라과이" },
  "australia": { "en": "Australia", "zh": "澳大利亚", "ja": "オーストラリア", "ko": "오스트레일리아" },
  "turkey": { "en": "Türkiye", "zh": "土耳其", "ja": "トルコ", "ko": "튀르키예" },

  // E组
  "germany": { "en": "Germany", "zh": "德国", "ja": "ドイツ", "ko": "독일" },
  "curacao": { "en": "Curaçao", "zh": "库拉索", "ja": "キュラソー", "ko": "퀴라소" },
  "ivory-coast": { "en": "Côte d'Ivoire", "zh": "科特迪瓦", "ja": "コートジボワール", "ko": "코트디부아르" },
  "ecuador": { "en": "Ecuador", "zh": "厄瓜多尔", "ja": "エクアドル", "ko": "에콰도르" },

  // F组
  "netherlands": { "en": "Netherlands", "zh": "荷兰", "ja": "オランダ", "ko": "네덜란드" },
  "japan": { "en": "Japan", "zh": "日本", "ja": "日本", "ko": "일본" },
  "sweden": { "en": "Sweden", "zh": "瑞典", "ja": "スウェーデン", "ko": "스웨덴" },
  "tunisia": { "en": "Tunisia", "zh": "突尼斯", "ja": "チュニジア", "ko": "튀니지" },

  // G组
  "belgium": { "en": "Belgium", "zh": "比利时", "ja": "ベルギー", "ko": "벨기에" },
  "egypt": { "en": "Egypt", "zh": "埃及", "ja": "エジプト", "ko": "이집트" },
  "iran": { "en": "Iran", "zh": "伊朗", "ja": "イラン", "ko": "이란" },
  "new-zealand": { "en": "New Zealand", "zh": "新西兰", "ja": "ニュージーランド", "ko": "뉴질랜드" },

  // H组
  "spain": { "en": "Spain", "zh": "西班牙", "ja": "スペイン", "ko": "스페인" },
  "cape-verde": { "en": "Cape Verde", "zh": "佛得角", "ja": "カーボベルデ", "ko": "카보베르데" },
  "saudi-arabia": { "en": "Saudi Arabia", "zh": "沙特阿拉伯", "ja": "サウジアラビア", "ko": "사우디아라비아" },
  "uruguay": { "en": "Uruguay", "zh": "乌拉圭", "ja": "ウルグアイ", "ko": "우루과이" },

  // I组
  "france": { "en": "France", "zh": "法国", "ja": "フランス", "ko": "프랑스" },
  "senegal": { "en": "Senegal", "zh": "塞内加尔", "ja": "セネガル", "ko": "세네갈" },
  "iraq": { "en": "Iraq", "zh": "伊拉克", "ja": "イラク", "ko": "이라크" },
  "norway": { "en": "Norway", "zh": "挪威", "ja": "ノルウェー", "ko": "노르웨이" },

  // J组
  "argentina": { "en": "Argentina", "zh": "阿根廷", "ja": "アルゼンチン", "ko": "아르헨티나" },
  "algeria": { "en": "Algeria", "zh": "阿尔及利亚", "ja": "アルジェリア", "ko": "알제리" },
  "austria": { "en": "Austria", "zh": "奥地利", "ja": "オーストリア", "ko": "오스트리아" },
  "jordan": { "en": "Jordan", "zh": "约旦", "ja": "ヨルダン", "ko": "요르단" },

  // K组
  "portugal": { "en": "Portugal", "zh": "葡萄牙", "ja": "ポルトガル", "ko": "포르투갈" },
  "dr-congo": { "en": "DR Congo", "zh": "刚果(金)", "ja": "コンゴ民主共和国", "ko": "콩고 민주 공화국" },
  "uzbekistan": { "en": "Uzbekistan", "zh": "乌兹别克斯坦", "ja": "ウズベキスタン", "ko": "우즈베키스탄" },
  "colombia": { "en": "Colombia", "zh": "哥伦比亚", "ja": "コロンビア", "ko": "콜롬비아" },

  // L组
  "england": { "en": "England", "zh": "英格兰", "ja": "イングランド", "ko": "잉글랜드" },
  "croatia": { "en": "Croatia", "zh": "克罗地亚", "ja": "クロアチア", "ko": "크로아티아" },
  "ghana": { "en": "Ghana", "zh": "加纳", "ja": "ガーナ", "ko": "가나" },
  "panama": { "en": "Panama", "zh": "巴拿马", "ja": "パナマ", "ko": "파나마" },

  // 举办国
  "united-states": { "en": "United States", "zh": "美国", "ja": "アメリカ合衆国", "ko": "미국" }
};

export const getTeamName = (key, lang) => {
  if (!key) return '';
  const team = teamNames[key];
  return team ? team[lang] || team['en'] || key : key;
};
